<p-progressBar
  *ngIf="loading"
  mode="indeterminate"
  [attr.aria-label]="UI_STRINGS.LOADING | translateString"
  role="alert"
></p-progressBar>
